$(document).ready(function() {

    var progressPath = document.querySelector('.progress-wrap path');
    if ( progressPath ) {
        var pathLength = progressPath.getTotalLength();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
        progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
        progressPath.style.strokeDashoffset = pathLength;
        progressPath.getBoundingClientRect();
        progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';

        var updateProgress = function () {
            var scroll = $(window).scrollTop();
            var height = $(document).height() - $(window).height();
            var progress = pathLength - (scroll * pathLength / height);
            progressPath.style.strokeDashoffset = progress;
        }

        updateProgress();
        $(window).scroll(updateProgress);

        var offset = 50;
        var duration = 550;

        jQuery(window).on('scroll', function () {
            if (jQuery(this).scrollTop() > offset) {
                jQuery('.progress-wrap').addClass('active-progress');
            } else {
                jQuery('.progress-wrap').removeClass('active-progress');
            }
        });

        jQuery('.progress-wrap').on('click', function (event) {
            event.preventDefault();
            jQuery('html, body').animate({scrollTop: 0}, duration);
            return false;
        })
    }
});
window.playingIndex = 0;

window.stopTextToAudio = function() {
    window.playingIndex = 4;
    window.speechSynthesis.cancel();
    setTimeout(function (){
        window.playingIndex = 0;
    },500);
}

window.onbeforeunload = function(){
    stopTextToAudio();
};

window.speakMessage = function ( lang, PAUSE_MS = 500, action = 'play') {
    try {
        const messageParts = [
            document.getElementById('title').innerText,
            document.getElementById("introText").innerText,
            document.getElementById('fulltext').innerText
        ]


        const speak = (textToSpeak) => {
            const msg = new SpeechSynthesisUtterance();
            msg.volume = 1; // 0 to 1
            msg.rate = 1; // 0.1 to 10
            msg.pitch = .1; // 0 to 2
            msg.text = textToSpeak;
            msg.lang = lang;
            msg.onend = function() {
                window.playingIndex++;
                if (window.playingIndex < messageParts.length) {
                    setTimeout(() => {
                        speak(messageParts[window.playingIndex])
                    }, PAUSE_MS)
                }
            };
            speechSynthesis.speak(msg);
        }
        speak(messageParts[0])
    } catch (e) {
        console.error(e)
    }
}

let zoom = 1;
$('.zoom').on('click', function(){
    if (zoom < 1.2){

        zoom += 0.05;
        let element = (window.location.href.indexOf("/login") > -1) ? "main" :  "#page-container";

        $(element).css({
            "transform": "scale(" + zoom +")",
            "transform-origin": "top",
            "-moz-transform": "scale(" + zoom +")",
            "-moz-transform-origin": "top"
        });
    }
});
$('.zoomOut').on('click', function(){
    if (zoom > 1){

        zoom -= 0.05;
        let element = (window.location.href.indexOf("/login") > -1) ? "main" :  "#page-container";
        if ( zoom == 1) {
            $(element).css({
                "transform": "initial",
                "transform-origin": "initial",
                "-moz-transform": "initial",
                "-moz-transform-origin": "initial"
            });
            return false;
        }
        $(element).css({
            "transform": "scale(" + zoom +")",
            "transform-origin": "top",
            "-moz-transform": "scale(" + zoom +")",
            "-moz-transform-origin": "top"
        });

    }

});

$.fn.isInViewport = function() {
    var elementTop = parseInt($(this).offset().top - 80);
    var elementBottom = parseInt(elementTop + $(this).outerHeight() );

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
